interface StatCardProps {
  icon: string;
  label: string;
  value: string | number;
  trend?: { value: string; positive: boolean };
  accentClass?: string;
}

export default function StatCard({ icon, label, value, trend, accentClass = "bg-[var(--color-accent)]/10 text-[var(--color-text-accent)]" }: StatCardProps) {
  const arrowIcon = trend ? (trend.positive ? "ri-arrow-up-line" : "ri-arrow-down-line") : "";

  return (
    <div className="card hover:border-[var(--color-border-light)] cursor-pointer group">
      <div className="flex items-start justify-between">
        <div className="space-y-1">
          <p className="text-xs text-[var(--color-text-muted)] font-medium uppercase tracking-wider">{label}</p>
          <p className="text-2xl font-bold text-[var(--color-text-primary)]">{value}</p>
          {trend && (
            <p className={`text-xs font-medium flex items-center gap-1 ${trend.positive ? "text-green-400" : "text-red-400"}`}>
              <i className={arrowIcon}></i>
              {trend.value}
            </p>
          )}
        </div>
        <div className={`w-11 h-11 rounded-xl flex items-center justify-center ${accentClass}`}>
          <i className={`${icon} text-xl`}></i>
        </div>
      </div>
    </div>
  );
}